import { render, staticRenderFns } from "./BarangKeluar.vue?vue&type=template&id=5a5c78be"
import script from "./BarangKeluar.vue?vue&type=script&lang=js"
export * from "./BarangKeluar.vue?vue&type=script&lang=js"
import style0 from "./BarangKeluar.vue?vue&type=style&index=0&id=5a5c78be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports